export default __webpack_public_path__ + "e0dc75b7fe8f0059f14ca1e170c1c2f7.png";